/* eslint-disable no-unused-vars */
import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonContent,
  IonButton,
} from '@ionic/react';
import { Stack, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import './SmartGoals.css';
import appStrings from 'common/app_strings';
import appColors from 'common/app_colors';
import { useHistory } from 'react-router-dom';

const { goals: { smartGoals: STRINGS } } = appStrings;
const { container, text } = appColors;

const SmartGoals = ({ onComplete, onBack }) => {
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar className="back-button-toolbar back-button-toolbar-blue" mode="ios" style={{ '--background: ': container.darkNavy }}>
          <IonButtons slot="start">
            <IonBackButton
              text=""
              className="back-button-custom"
              icon="/assets/back-arrow.svg"
              style={{
                '--icon-font-size': '1.25rem',
                '--icon-padding-start': '8px',
                '--icon-padding-end': '12px',
                '--icon-padding-top': '4px',
                '--icon-margin-end': '6px',
                color: text.whiteText,
              }}
              mode="ios"
              defaultHref="/"
              {...(onBack && { onClick: onBack })}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent
        style={{
          '--background': container.darkNavy,
          '--padding-start': '24px',
          '--padding-end': '24px',
        }}
        fullscreen
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
          }}
        >
          <Stack>
            <Typography
              mt={3}
              mb={2}
              color={text.whiteText}
              fontSize={20}
              fontWeight={700}
              sx={{ textAlign: 'center' }}
            >
              {STRINGS.whatIs}
              <Typography
                component="span"
                sx={{
                  color: text.gold,
                  mb: 2,
                  fontSize: 24,
                  fontWeight: 700,
                  verticalAlign: 'baseline',
                }}
              >
                {' '}
                {STRINGS.smart}
                {' '}
              </Typography>
              {STRINGS.goal}
            </Typography>
            <Typography
              color={text.whiteText}
              mb={3.5}
              px={2}
              sx={{ textAlign: 'center', lineHeight: 1.25 }}
            >
              {STRINGS.whenDesigning}
            </Typography>
            <Stack spacing={3} mb={6}>
              <div className="goals-smart-item">
                <Typography
                  color={text.gold}
                  fontSize={50}
                  width="22%"
                  textAlign="center"
                  lineHeight={0.9}
                  mr={1}
                >
                  {STRINGS.SMART[0]}
                </Typography>
                <div className="goals-smart-description">
                  <Typography color={text.gold} fontSize={20} fontWeight={700}>
                    {STRINGS.specific}
                  </Typography>
                  <Typography color={text.whiteText} fontSize={14} lineHeight={1.25}>
                    {STRINGS.directDetailedMeaningful}
                  </Typography>
                </div>
              </div>
              <div className="goals-smart-item">
                <Typography
                  color={text.gold}
                  fontSize={50}
                  width="22%"
                  textAlign="center"
                  lineHeight={0.9}
                  mr={1}
                >
                  {STRINGS.SMART[1]}
                </Typography>
                <div className="goals-smart-description">
                  <Typography color={text.gold} fontSize={20} fontWeight={700}>
                    {STRINGS.measureable}
                  </Typography>
                  <Typography color={text.whiteText} fontSize={14} lineHeight={1.25}>
                    {STRINGS.quantifiable}
                  </Typography>
                </div>
              </div>
              <div className="goals-smart-item">
                <Typography
                  color={text.gold}
                  fontSize={50}
                  width="22%"
                  textAlign="center"
                  lineHeight={0.9}
                  mr={1}
                >
                  {STRINGS.SMART[2]}
                </Typography>
                <div className="goals-smart-description">
                  <Typography color={text.gold} fontSize={20} fontWeight={700}>
                    {STRINGS.attainable}
                  </Typography>
                  <Typography color={text.whiteText} fontSize={14} lineHeight={1.25}>
                    {STRINGS.realistic}
                  </Typography>
                </div>
              </div>
              <div className="goals-smart-item">
                <Typography
                  color={text.gold}
                  fontSize={50}
                  width="22%"
                  textAlign="center"
                  lineHeight={0.9}
                  mr={1}
                >
                  {STRINGS.SMART[3]}
                </Typography>
                <div className="goals-smart-description">
                  <Typography color={text.gold} fontSize={20} fontWeight={700}>
                    {STRINGS.relevant}
                  </Typography>
                  <Typography color={text.whiteText} fontSize={14} lineHeight={1.25}>
                    {STRINGS.aligns}
                  </Typography>
                </div>
              </div>
              <div className="goals-smart-item">
                <Typography
                  color={text.gold}
                  fontSize={50}
                  width="22%"
                  textAlign="center"
                  lineHeight={0.9}
                  mr={1}
                >
                  {STRINGS.SMART[4]}
                </Typography>
                <div className="goals-smart-description">
                  <Typography color={text.gold} fontSize={20} fontWeight={700}>
                    {STRINGS.timeBased}
                  </Typography>
                  <Typography color={text.whiteText} fontSize={14} lineHeight={1.25}>
                    {STRINGS.description}
                  </Typography>
                </div>
              </div>
            </Stack>
          </Stack>
          <IonButton
            style={{
              '--color': text.whiteText,
              '--border-color': text.whiteText,
              marginBottom: '24px',
              fontWeight: 700,
              minHeight: '57px',
            }}
            size="large"
            expand="block"
            shape="round"
            fill="outline"
            {...(onComplete ? { onClick: () => onComplete() } : { onClick: () => history.push('/goals-create') })}
          >
            {STRINGS.gotIt}
          </IonButton>
        </Box>
      </IonContent>
    </IonPage>
  );
};

SmartGoals.propTypes = {
  onComplete: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SmartGoals;
